export enum GlobalReportsViewTabId {
	Utilisation = "utilisation",
	TeamUtilisation = "teamUtilisation",
	DailyRate = "dailyRate",
	Revenue = "revenue",
}

export enum GlobalReportsViewTabDisplayNames {
	utilisation = "Auslastung",
	teamUtilisation = "Team-Auslastung",
	dailyRate = "Tagessatz",
	revenue = "Umsatz",
}
